(ns common.tol-a)

(defonce tol-a
  [[:A "Maatalous, metsätalous ja kalatalous"]
   [:B "Kaivostoiminta ja louhinta"]
   [:C "Teollisuus"]
   [:D "Sähkö-, kaasu- ja lämpöhuolto, jäähdytysliiketoiminta"]
   [:E "Vesihuolto, viemäri- ja jätevesihuolto, jätehuolto ja muu ympäristön puhtaanapito"]
   [:F "Rakentaminen"]
   [:G "Tukku- ja vähittäiskauppa: moottoriajoneuvojen ja moottoripyörien korjaus"]
   [:H "Kuljetus ja varastointi"]
   [:I "Majoitus- ja ravitsemistoiminta"]
   [:J "Informaatio ja viestintä"]
   [:K "Rahoitus- ja vakuutustoiminta"]
   [:L "Kiinteistöalan toiminta"]
   [:M "Ammatillinen, tieteellinen ja tekninen toiminta"]
   [:N "Hallinto- ja tukipalvelutoiminta"]
   [:O "Julkinen hallinto ja maanpuolustus: pakollinen sosiaalivakuutus"]
   [:P "Koulutus"]
   [:Q "Terveys- ja sosiaalipalvelut"]
   [:R "Taiteet, viihde ja virkistys"]
   [:S "Muu palvelutoiminta"]
   [:T "Kotitalouksien toiminta työnantajina: kotitalouksien eriyttämätön toiminta tavaroiden ja palvelujen tuottamiseksi omaan käyttöön"]
   [:U "Kansainvälisten organisaatioiden ja toimielinten toiminta"]
   [:X "Toimiala tuntematon"]])

(defonce options
         (->> tol-a
              (map (fn [[k l]]
                     {:key   k
                      :label l}))))

(defn get-label [key]
  (some #(when (= key (first %)) (second %)) tol-a))

(defn get-key [label]
  (some #(when (= label (second %)) (first %)) tol-a))
